import * as React from 'react';
import { useEffect } from 'react';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import MuiCheckbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@mui/material';
import { AdditionalTravellerFieldEnum } from '../../../../../../../Passenger/types';
import { SafeHtml } from '@shared/ui';
const Checkbox = props => {
    const theme = useTheme('PassengerForm').Accompanying;
    const { t } = useTranslation('Passenger');
    const checkboxField = props.accompanyingFields.find(field => field.type === AdditionalTravellerFieldEnum.AccompanyingCheck);
    const { input, meta } = useField(`customer.${checkboxField.name}`, {
        type: 'checkbox',
        initialValue: checkboxField.defaultValue,
        validate: value => {
            if (!value) {
                return t('Required');
            }
            return undefined;
        }
    });
    useEffect(() => {
        input.onBlur();
    }, [input.value]);
    return (React.createElement("div", { className: theme.checkbox },
        React.createElement(FormControlLabel, { control: React.createElement(MuiCheckbox, { color: 'primary', classes: {
                    root: theme.formControl__checkbox,
                    checked: theme.checkbox__checked
                }, checked: input.checked, inputProps: Object.assign({}, input) }), classes: {
                label: theme.formControl__label
            }, label: React.createElement(SafeHtml, { tag: "div", html: t('I confirm that the provided ticket number and the name of the accompanying passenger are correct and valid.') }) }),
        React.createElement("div", { className: theme.error }, meta.submitFailed && meta.error)));
};
export default Checkbox;
